import { call, put, takeLatest, all } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

export function* handleFetchClients({ payload }) {
  try {
    const res = yield call(API.fetchCompaniesForFilter, payload);
    const { data } = res;
    yield put(actions.fetchClientsSuccess(data));
  } catch (err) {
    yield put(actions.fetchClientsFailure(err?.response?.data));
  }
}

export function* handleFetchProjects({ payload }) {
  try {
    const res = yield call(API.fetchProjectCodesForFilters, payload?.query);
    const { data } = res;
    yield put(actions.fetchProjectsSuccess(data));
  } catch (err) {
    yield put(actions.fetchProjectsFailure(err?.response?.data));
  }
}

export function* handleFetchCommodities({ payload }) {
  try {
    const res = yield call(API.fetchAllCommoditiesForLab, payload);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(API.fetchAllStates, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchDistricts({ payload }) {
  try {
    const { stateIds } = payload;
    if (!stateIds || stateIds.length === 0) {
      yield put(actions.clearDistricts());
      return;
    }
    
    const responses = yield all(
      stateIds.map((stateId) => call(API.fetchDistrictsForState, { stateId }))
    );
    
    const allDistricts = [];
    
    responses.forEach((res) => {
      const districts = res.data?.data?.districts || [];
      const stateName = res.data?.data?.state;
      
      // Simply enhance districts with the state name from API
      const enhancedDistricts = districts.map(district => ({
        ...district,
        stateName: stateName // This is all we need!
      }));
      
      allDistricts.push(...enhancedDistricts);
    });
    
    yield put(
      actions.fetchDistrictsSuccess({ 
        data: { 
          districts: allDistricts
        } 
      })
    );
  } catch (err) {
    yield put(actions.fetchDistrictsFailure(err?.response?.data));
  }
}

export function* handleFetchSamplers({ payload }) {
  try {
    const allSamplers = [];
    for (const stateId of payload.stateIds) {
      for (const districtId of payload.districtIds) {
        const res = yield call(API.fetchSamplersForDistrict, { stateId, districtId });
        const { data } = res;
        if (data?.data?.sampler) {
          allSamplers.push(...data.data.sampler);
        }
      }
    }
    yield put(actions.fetchSamplersSuccess(allSamplers));
  } catch (err) {
    yield put(actions.fetchSamplersFailure(err?.response?.data));
  }
}

export function* handleFetchLabs({ payload }) {
  try {
    // Keep the existing API call as it already fetches all labs
    const res = yield call(API.fetchAllLabs, payload);
    const { data } = res;
    yield put(actions.fetchLabsSuccess(data));
  } catch (err) {
    yield put(actions.fetchLabsFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* reportFiltersSaga() {
  yield takeLatest(actions.fetchClients.type, handleFetchClients);
  yield takeLatest(actions.fetchProjects.type, handleFetchProjects);
  yield takeLatest(actions.fetchCommodities.type, handleFetchCommodities);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchDistricts.type, handleFetchDistricts);
  yield takeLatest(actions.fetchSamplers.type, handleFetchSamplers);
  yield takeLatest(actions.fetchLabs.type, handleFetchLabs);
}